import { application } from './app';

application.register('accordion', require('./accordion_controller').default);
application.register('application', require('./application_controller').default);
application.register('autocomplete', require('./autocomplete_controller').default);
application.register('button', require('./button_controller').default);
application.register('charts', require('./charts_controller').default);
application.register('copy-to-clipboard', require('./copy_to_clipboard_controller').default);
application.register('cropper', require('./cropper_controller').default);
application.register('dashboard', require('./dashboard_controller').default);
application.register('dropdown', require('./dropdown_controller').default);
application.register('filter--date-ranges-popover', require('./filter/date_ranges_popover_controller').default);
application.register('filter--date-ranges-text', require('./filter/date_ranges_text_controller').default);
application.register('filter--filter-popover', require('./filter/filter_popover_controller').default);
application.register('masked-field', require('./masked_field_controller').default);
application.register('modal', require('./modal_controller').default);
application.register('modalforms', require('./modalforms_controller').default);
application.register('payments', require('./payments_controller').default);
application.register('payments--transactions', require('./payments/transactions_controller').default);
application.register('popover', require('./popover_controller').default);
application.register('search', require('./search_controller').default);
application.register('signup-codes', require('./signup_codes_controller').default);
application.register('starting-points', require('./starting_points_controller').default);
application.register('transactions', require('./transactions_controller').default);
application.register('transactions--events', require('./transactions/events_controller').default);
application.register('turbolist', require('./turbolist_controller').default);
application.register('users', require('./users_controller').default);
